var render, staticRenderFns
import script from "./SurgeryMixin.vue?vue&type=script&lang=ts&"
export * from "./SurgeryMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357d0436')) {
      api.createRecord('357d0436', component.options)
    } else {
      api.reload('357d0436', component.options)
    }
    
  }
}
component.options.__file = "src/components/shared/SurgeryMixin.vue"
export default component.exports